var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerIconGas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m18.735 6.78.139.125.001-.001L21.5 9.279v7.742c0 1.295-1.215 2.32-2.598 2.059-1.029-.193-1.736-1.127-1.736-2.142V14.4h-1.291V18.6h.735V20H6.5v-1.4h.626V6.816c0-.45.375-.816.836-.816h7.076c.462 0 .837.365.837.816V13h1.291c.8 0 1.445.627 1.445 1.4v2.62c0 .387.325.7.721.7a.712.712 0 0 0 .724-.7v-5.49l-.972-1.007v-1.53L17.75 7.803zm-4.292 4.82H8.666V7.4h5.777z",
    clipRule: "evenodd"
  })));
}
export default SvgMarkerIconGas;